import type { FacetConfig } from '../../../shared/components/FacetedFilterRail';
import type { LiveEvent } from '../../../types/frontend';
import { friendlyType, extractSeverity } from './eventDisplay';

const SEVERITY_ORDER = ['high', 'medium', 'low', 'info', 'none'];
const SEVERITY_LABEL: Record<string, string> = {
  high: 'High', medium: 'Medium', low: 'Low', info: 'Info', none: 'No severity',
};

const sevKey = (e: LiveEvent): string => extractSeverity(e)?.level ?? 'none';

export const EVENT_FACETS: FacetConfig<LiveEvent>[] = [
  { key: 'types', title: 'What happened', keyOf: friendlyType },
  { key: 'severities', title: 'Severity', keyOf: sevKey, order: SEVERITY_ORDER, labelOf: (k) => SEVERITY_LABEL[k] ?? k },
  { key: 'sources', title: 'Source', keyOf: (e) => e.source, advanced: true },
  { key: 'regions', title: 'Region', keyOf: (e) => e.region, advanced: true },
  { key: 'accounts', title: 'Account', keyOf: (e) => e.account, advanced: true },
];
